<template>
  <div class="progress-cirlce">
    <div class="progress-cirlce__inner">
      <svg viewBox="0 -10 220 110" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" :style="startColorStyle" />
            <stop offset="100%" :style="endColorStyle" />
          </linearGradient>
        </defs>
        <path d="M 20 100 A 90 90 0 1 1 200 100" fill="none" stroke="#e6e6e6" stroke-width="30" />
        <path 
          d="M 20 100 A 90 90 0 1 1 200 100" 
          fill="none" 
          stroke="url(#gradient)" 
          stroke-width="30"
          :stroke-dasharray="strokeDashArray"
          stroke-dashoffset="0" 
        />
      </svg>
      <div class="progress-cirlce__center-text">
        <h5>{{ title }}</h5>
        <div class="progress-cirlce__current gradient">
          {{ currentProgress }}%
        </div>
      </div>
    </div>
    <div class="process-circle__info" dir="ltr">
      <Flex justify="space-between" align="center">
        <div class="process-circle__num">{{ start }}{{ endData.unit }}</div>
        <div class="process-circle__left">{{ left.endValue }}<span v-if="!disableUnit">{{ left.unit }}</span> {{ __('left') }} </div>
        <div class="process-circle__num">{{ endData.endValue }}<span v-if="!disableUnit">{{ endData.unit }}</span></div>
      </Flex>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import {  __, formatBytes } from '@/utils'
  import Flex from '@components/flex/flex.vue';
  
  const { startColor, endColor, current, end, disableUnit } = defineProps({
    startColor: {
      type: String,
      default: '#50C8EE'
    },
    endColor: {
      type: String,
      default: '#463C96'
    },
    current: {
      type: Number,
      default: 0,
      required: true,
    },
    start: String,
    end: Number,
    title: String,
    disableUnit: {
      type: Boolean,
      default: false
    }
  });

  const endData = computed(() => disableUnit ? {endValue: end} : formatBytes(end));

  const startColorStyle = `stop-color: ${startColor}; stop-opacity:1`;
  const endColorStyle = `stop-color: ${endColor}; stop-opacity:1`;
  const currentProgress = computed(() => ((parseInt(current) / parseInt(end)).toFixed(2) * 100).toFixed(2));
  const left = computed(() => disableUnit ? {endValue: end - current} : formatBytes(parseInt(end) - parseInt(current)));

  const strokeDashArray = computed(() => {
    const circumference = Math.PI * 180;
    const current = currentProgress.value / 100;
    const progressLength = (current * circumference) / 2;
    return `${progressLength} ${circumference}`;
});
</script>
  